module.exports = __webpack_public_path__ + "d7e07e527a2102c66ee402c92da85ecb.pdf";